import { render, staticRenderFns } from "./DocumentDetailDialog.vue?vue&type=template&id=5dad7cba&scoped=true&"
import script from "./DocumentDetailDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailDialog.vue?vue&type=style&index=0&id=5dad7cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad7cba",
  null
  
)

export default component.exports